import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  UncontrolledTooltip,
} from "reactstrap";
import Select from "react-select";
import { Link } from "react-router-dom";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { changeSkillMappingStatus, fetchDepartments, fetchDesignations, fetchPositionsByDeptRole, fetchSkillMapping, saveSkillMapping } from "store/actions";
import CustomSelect from "components/Common/custom-select";
import Loader from "common/pageLoader";
import Swal from "sweetalert2";
import { post } from "helpers/api_helper";

const competencyOptions = [
  { value: 1, label: "TECHNICAL SKILLS" },
  { value: 2, label: "BUSINESS SKILLS" },
  { value: 3, label: "LEADERSHIP SKILLS" },
  { value: 4, label: "PEOPLE SKILLS" },
];

const expertiseOptions = [
  { value: 1, label: "Beginner" },
  { value: 2, label: "Intermediate" },
  { value: 3, label: "Advanced" },
  { value: 4, label: "Expert" },
];

const SkillMapping = () => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    skillMappings,
    designations,
    departments,
    filteredPositions,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    skillMappings: state.JobSetupPositionSkillReducer?.skillMappings ?? [],
    filteredPositions: state.JobSetupPositionSkillReducer?.filteredPositions ?? [],
    designations: state.DesignationMaster?.designations ?? [],
    departments: state.DepartmentMaster?.departments ?? [],

    loading: state.JobSetupPositionSkillReducer?.loading || state.DesignationMaster?.loading || state.DepartmentMaster?.loading,
    error: state.JobSetupPositionSkillReducer?.error || state.DesignationMaster?.error || state.DepartmentMaster?.error,
    success: state.JobSetupPositionSkillReducer?.success,
  }));

  const [skillOptions, setSkillOptions] = useState([]);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchSkillMapping(unitId));
    dispatch(fetchDesignations(unitId))
    dispatch(fetchDepartments(unitId))
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(fetchSkillMapping(authDetails?.unit_id));
      setIsEdit(false);
      setEditId(null);
      formik.resetForm()
    }
  }, [authDetails, success, dispatch]);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      department: null,
      role: null,
      position: null,
      competency: null,
      skills: null,
      expertise: null,
      description: "",
    },
    validationSchema: Yup.object({
      department: Yup.object().nullable().required("Please select a department."),
      role: Yup.object().nullable().required("Please select a role."),
      position: Yup.object().nullable().required("Please select a position."),
      competency: Yup.object().nullable().required("Please select a competency."),
      skills: Yup.object().nullable().required("Please select a skill."),
      expertise: Yup.object().nullable().required("Please select expertise level."),
      description: Yup.string().required("Please enter description."),
    }),
    onSubmit: (values, { resetForm }) => {
      const payload = new FormData();
      payload.append("mcs_id", isEdit ? editId : 0);
      payload.append("dept_id", values.department?.value);
      payload.append("role_id", values.role?.value);
      payload.append("position_id", values.position?.value);
      payload.append("compentency_id", values.competency?.value);
      payload.append("skill_id", values.skills?.value);
      payload.append("skill_expertise_id", values.expertise?.value);
      payload.append("description", values.description);
      payload.append("unit_id", authDetails?.unit_id);
      payload.append("created_by", authDetails?.user_id);
      dispatch(saveSkillMapping(payload))
    },
  });

  const handleEdit = (row) => {
    console.log('row > ',row)
    setIsEdit(true);
    setEditId(row.mcs_id);
    const departmentObj = (departments || []).find(
      emp => emp.departmentId === row.dept_id
    );
    const roleObj = (designations || []).find(
      r => r.desig_id === row.role_id
    );
    
    formik.setValues({
      department: {
        value: departmentObj?.departmentId,
        label: departmentObj?.departmentname
      },
      role: {
        value: roleObj?.desig_id,
        label: roleObj?.designation
      },
      position: { value: row.pos_id, label: row.position },
      competency: { value: row.com_id, label: row.compentency },
      skills: { value: row.skill_id, label: row.skills },
      expertise: { value: row.skill_expertise_id, label: row.skill_expertise },
      description: row.description || "",
    });
    dispatch(fetchPositionsByDeptRole(row.dept_id, row.role_id, authDetails?.unit_id));
    fetchSkillsByCompetency(row.com_id);
  };

  const fetchSkillsByCompetency = async (competencyId) => {
    try {
      const formData = new FormData();
      formData.append('competency_id', competencyId || '');
      formData.append('unit_id', authDetails?.unit_id || '');
      const response = await post(process.env.REACT_APP_FETCH_SKILLS_BY_COMPETENCY, formData);
      if (response.status === 'success') {
        setSkillOptions(response.data.map(skill => ({ value: skill.skill_id, label: skill.skill_name })));
      }
    } catch (error) {
      console.error('Error fetching skills:', error);
      setSkillOptions([]);
    }
  };

  const columns = [
    {
      Header: "S.No",
      Cell: ({ row }) => skillMappings.length - row.index,
      className: "serial-no",
      applyHeaderClass: true,
    },
    {
      Header: "Action",
      Cell: (cellProps) => {
        const { b_active, mcs_id } = cellProps.row.original;
        const isActive = b_active === 1; // Status 1 = Active
        return (
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-success"
              onClick={() => handleEdit(cellProps.row.original)}
            >
              <i className="bx bxs-edit font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
              </UncontrolledTooltip>
            </Link>
            <Link
              to="#"
              style={{ color: isActive ? "green" : "red" }}
              onClick={() => handleToggleStatus(mcs_id, isActive)}
            >
              <i
                className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`}
                id={`status-tooltip-${cellProps.row.mcs_id}`}
              />
              <UncontrolledTooltip placement="top" target={`status-tooltip-${cellProps.row.mcs_id}`}>
                {isActive ? "Mark Inactive" : "Mark Active"}
              </UncontrolledTooltip>
            </Link>
          </div>
        );
      },
    },
    { Header: "Department", accessor: "department" },
    { Header: "Role", accessor: "role" },
    { Header: "Position", accessor: "position" },
    { Header: "Competency", accessor: "compentency" },
    { Header: "Expertise", accessor: "skill_expertise" },
    {
      Header: "Skills",
      accessor: "skills",
      Cell: ({ value }) => (
        <div style={{ whiteSpace: 'pre-line' }}>
          {(value || "").split('\n').map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </div>
      )
    },
  ];

  const handleToggleStatus = (id, isActive) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to ${isActive ? 'deactivate' : 'activate'} this.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      reverseButtons: false,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("mcs_id", id);
        formData.append("unit_id", authDetails?.unit_id);
        formData.append("created_by", authDetails?.user_id);
        dispatch(changeSkillMappingStatus(formData));
      }
    });
  };
  const SelectcustomStyles = {
    control: (base) => ({ ...base, minHeight: 33.1, maxHeight: 33.1 }),
    dropdownIndicator: (base) => ({ ...base, padding: "2px 8px" }),
    clearIndicator: (base) => ({ ...base, padding: "2px 8px" }),
    valueContainer: (base) => ({ ...base, padding: "0px 8px" }),
    input: (base) => ({ ...base, margin: 0, padding: 0 }),
  };


  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Job setup" breadcrumbItem="Skill Mapping" />

        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row className=" mb-3">
                {/* Department */}
                <Col md="3">
                  <FormGroup>
                    <Label>Department <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="department"
                      name="department"
                      options={departments.map(emp => ({ value: emp.departmentId, label: emp.departmentname }))}
                      value={formik.values.department}
                      onChange={selectedOption => {
                        formik.setFieldValue("department", selectedOption);
                        formik.setFieldValue("position", null);
                        const selectedRole = formik.values.role;
                        if (selectedOption?.value && selectedRole?.value) {
                          dispatch(fetchPositionsByDeptRole(selectedOption.value, selectedRole.value, authDetails?.unit_id));
                        }
                      }}
                      onBlur={() => formik.setFieldTouched("department", true)}  // ✅ Ensure onBlur is handled
                      classNamePrefix="react-select"
                      isDisabled={isEdit}
                      styles={SelectcustomStyles}
                    />
                    {formik.touched.department && formik.errors.department && (
                      <div className="text-danger">{formik.errors.department}</div>
                    )}
                  </FormGroup>
                </Col>

                {/* Role */}
                <Col md="3">
                  <FormGroup>
                    <Label>Role <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="role"
                      name="role"
                      options={designations.map(emp => ({ value: emp.desig_id, label: emp.designation }))}
                      value={formik.values.role}
                      onChange={selectedOption => {
                        formik.setFieldValue("role", selectedOption);
                        formik.setFieldValue("position", null);
                        const selectedDept = formik.values.department;
                        if (selectedDept?.value && selectedOption?.value) {
                          dispatch(fetchPositionsByDeptRole(selectedDept.value, selectedOption.value, authDetails?.unit_id));
                        }
                      }}
                      onBlur={() => formik.setFieldTouched("role", true)}  // ✅ Ensure onBlur is handled
                      classNamePrefix="react-select"
                      isDisabled={isEdit}
                      styles={SelectcustomStyles}
                    />
                    {formik.touched.role && formik.errors.role && (
                      <div className="text-danger">{formik.errors.role}</div>
                    )}
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label>Position <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="position"
                      name="position"
                      // options={filteredPositions}
                      options={filteredPositions.map(emp => ({ value: emp.mpos_id, label: emp.pos }))}
                      value={formik.values.position}
                      onChange={selectedOption => formik.setFieldValue("position", selectedOption)}
                      onBlur={() => formik.setFieldTouched("position", true)}  // ✅ Ensure onBlur is handled
                      classNamePrefix="react-select"
                      isDisabled={isEdit}
                      styles={SelectcustomStyles}
                    />
                    {formik.touched.position && formik.errors.position && (
                      <div className="text-danger">{formik.errors.position}</div>
                    )}
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label>Competency <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="competency"
                      name="competency"
                      options={competencyOptions}
                      value={formik.values.competency}
                      onChange={selectedOption => {
                        formik.setFieldValue("competency", selectedOption);
                        formik.setFieldValue("skills", null);
                        if (selectedOption?.value) {
                          fetchSkillsByCompetency(selectedOption.value);
                        } else {
                          setSkillOptions([]);
                        }
                      }}
                      onBlur={() => formik.setFieldTouched("competency", true)}
                      classNamePrefix="react-select"
                      isDisabled={isEdit}
                      styles={SelectcustomStyles}
                    />
                    {formik.touched.competency && formik.errors.competency && (
                      <div className="text-danger">{formik.errors.competency}</div>
                    )}
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label>Skills <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="skills"
                      name="skills"
                      options={skillOptions}
                      value={formik.values.skills}
                      onChange={selectedOption => formik.setFieldValue("skills", selectedOption)}
                      onBlur={() => formik.setFieldTouched("skills", true)}
                      classNamePrefix="react-select"
                      styles={SelectcustomStyles}
                      isDisabled={!formik.values.competency}
                    />
                    {formik.touched.skills && formik.errors.skills && (
                      <div className="text-danger">{formik.errors.skills}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Expertise Level <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="expertise"
                      name="expertise"
                      options={expertiseOptions}
                      value={formik.values.expertise}
                      onChange={selectedOption => formik.setFieldValue("expertise", selectedOption)}
                      onBlur={() => formik.setFieldTouched("expertise", true)}
                      classNamePrefix="react-select"
                      styles={SelectcustomStyles}
                    />
                    {formik.touched.expertise && formik.errors.expertise && (
                      <div className="text-danger">{formik.errors.expertise}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Description <span className="text-danger">*</span></Label>
                    <Input
                      type="textarea"
                      name="description"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      invalid={formik.touched.description && Boolean(formik.errors.description)}
                    />
                    {formik.touched.description && formik.errors.description && (
                      <div className="text-danger">{formik.errors.description}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={12} className="mob-center text-end pt-md-2 pt-0">
                  <Button type="submit" className="btn button-save me-2 mt-2">
                    <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                  </Button>
                  <Button type="button"
                    onClick={() => {
                      formik.handleReset();
                      setIsEdit(false);
                      setEditId(null);
                    }}
                    className="btn button-cancel mt-2"> <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={skillMappings && skillMappings.length ? skillMappings : []}
              isGlobalFilter={true}
              customPageSize={10}
              className="custom-table"
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default SkillMapping;

